import { type FC, useEffect, useRef, useState } from "react";
import { Presentation } from "./Presentation";
import { type CalendarProps } from "./type";

// 選択できない日付 disabledDate は下記のフォーマットで指定してください
// https://daypicker.dev/api/type-aliases/Matcher

export const Calendar: FC<CalendarProps> = (props) => {
  const { selectedDate } = props;
  const outerRef = useRef<HTMLDivElement>(null);
  const [isShow, setIsShow] = useState(false);

  const showCalendar = () => {
    setIsShow(true);
  };

  const hideCalendar = () => {
    setIsShow(false);
  };

  // カレンダー以外をクリックしたらカレンダーを閉じる
  useEffect(() => {
    const outsideClick = (e: MouseEvent) => {
      const el = outerRef.current;
      if (!el || el.contains(e.target as Node)) return;
      hideCalendar();
    };
    document.addEventListener("mousedown", (e) => outsideClick(e));
    return () => document.removeEventListener("mousedown", (e) => outsideClick(e));
  }, []);

  // 日付を選択したらカレンダーを閉じる
  useEffect(() => {
    if (!selectedDate) return;
    hideCalendar();
  }, [selectedDate]);

  return (
    <Presentation {...props} isShow={isShow} showCalendar={showCalendar} outerRef={outerRef} />
  );
};
